// selectStyles.js - React Select styles for light/dark mode

const lightStyles = {
  control: (base) => ({
    ...base,
    background: '#ffffff',
    borderColor: '#dee2e6',
    minHeight: '38px',
    borderRadius: '8px',
    boxShadow: 'none',
    '&:hover': {
      borderColor: '#3d7ffc'
    }
  }),
  menu: (base) => ({
    ...base,
    background: '#ffffff',
    border: '1px solid #dee2e6',
    borderRadius: '8px',
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.1)',
    zIndex: 9999
  }),
  menuList: (base) => ({
    ...base,
    padding: '4px',
  }),
  option: (base, state) => ({
    ...base,
    background: state.isSelected 
      ? 'rgba(61, 127, 252, 0.15)' 
      : state.isFocused 
        ? '#f0f2f5' 
        : 'transparent',
    color: state.isSelected ? '#3d7ffc' : '#2c3e50',
    borderRadius: '6px',
    padding: '8px 10px',
    fontSize: '13px',
    cursor: 'pointer',
    '&:hover': {
      background: '#f0f2f5',
      color: '#3d7ffc'
    }
  }),
  singleValue: (base) => ({
    ...base,
    color: '#2c3e50'
  }),
  multiValue: (base) => ({
    ...base,
    background: 'rgba(61, 127, 252, 0.1)',
    borderRadius: '4px',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: '#3d7ffc',
    fontSize: '12px',
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: '#3d7ffc',
    ':hover': {
      background: 'rgba(61, 127, 252, 0.2)',
      color: '#2d5fcc',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    maxHeight: '80px',
    overflowY: 'auto',
  }),
  placeholder: (base) => ({
    ...base,
    color: '#9ca3af'
  }),
  input: (base) => ({
    ...base,
    color: '#2c3e50'
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: '#dee2e6'
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: '#6c757d',
    '&:hover': {
      color: '#2c3e50'
    }
  }),
  clearIndicator: (base) => ({
    ...base,
    color: '#6c757d',
    '&:hover': {
      color: '#dc3545'
    }
  }),
  loadingIndicator: (base) => ({
    ...base,
    color: '#3d7ffc'
  })
};

const darkStyles = {
  control: (base) => ({
    ...base,
    background: 'rgba(14, 37, 72, 0.8)',
    borderColor: 'rgba(255, 255, 255, 0.15)',
    minHeight: '38px',
    borderRadius: '8px',
    boxShadow: 'none',
    '&:hover': {
      borderColor: 'rgba(61, 127, 252, 0.4)'
    }
  }),
  menu: (base) => ({
    ...base,
    background: '#092349',
    border: '1px solid rgba(255, 255, 255, 0.15)',
    borderRadius: '8px',
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.4)',
    zIndex: 9999
  }),
  menuList: (base) => ({
    ...base,
    padding: '4px',
  }),
  option: (base, state) => ({
    ...base,
    background: state.isSelected 
      ? 'rgba(61, 127, 252, 0.3)' 
      : state.isFocused 
        ? 'rgba(61, 127, 252, 0.15)' 
        : 'transparent',
    color: state.isSelected ? '#ffffff' : 'rgba(255, 255, 255, 0.85)',
    borderRadius: '6px',
    padding: '8px 10px',
    fontSize: '13px',
    cursor: 'pointer',
    '&:hover': {
      background: 'rgba(61, 127, 252, 0.2)',
      color: '#20bcd5'
    }
  }),
  singleValue: (base) => ({
    ...base,
    color: 'rgba(255, 255, 255, 0.9)'
  }),
  multiValue: (base) => ({
    ...base,
    background: 'rgba(61, 127, 252, 0.3)',
    borderRadius: '4px',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: '#ffffff',
    fontSize: '12px',
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: 'rgba(255, 255, 255, 0.7)',
    ':hover': {
      background: 'rgba(61, 127, 252, 0.5)',
      color: '#ffffff',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    maxHeight: '80px',
    overflowY: 'auto',
  }),
  placeholder: (base) => ({
    ...base,
    color: 'rgba(255, 255, 255, 0.4)'
  }),
  input: (base) => ({
    ...base,
    color: 'rgba(255, 255, 255, 0.9)'
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: 'rgba(255, 255, 255, 0.15)'
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: 'rgba(255, 255, 255, 0.5)',
    '&:hover': {
      color: 'rgba(255, 255, 255, 0.8)'
    }
  }),
  clearIndicator: (base) => ({
    ...base,
    color: 'rgba(255, 255, 255, 0.5)',
    '&:hover': {
      color: '#ff6b6b'
    }
  }),
  loadingIndicator: (base) => ({
    ...base,
    color: '#3d7ffc'
  })
};

export const getSelectStyles = (isLightMode) => isLightMode ? lightStyles : darkStyles;
